var SUM = 8;
/**
 * Multiplies 1sum (8px) to output a pixel value
 */
export var calculateVerticalRhythm = function (multiplier) {
    var ALLOWED_MULTIPLIERS = [0.25, 0.5, 1.5];
    var isWholeNumber = multiplier % 1 === 0;
    if (!(ALLOWED_MULTIPLIERS.includes(multiplier) || isWholeNumber)) {
        // eslint-disable-next-line
        console.error("Vertical Rhythm can only be modified by 0.25, 0.5, or a whole number,\n      ".concat(multiplier, " is an invalid value"));
    }
    return SUM * multiplier;
};
export var setChildMap = function (k, v) {
    var m = new Map();
    m.set(k, v);
    return m;
};
export default {};
/**
 *  * Applies a series of CSS text wrapping styles to enhance visual balance.
 *
 * - Defaults to `text-wrap: pretty` for optimal wrapping where supported.
 * - Falls back to `text-wrap: balance` in unsupported browsers.
 * - As a final fallback, applies `word-wrap: break-word` for older browsers.
 */
export var applyTextWrap = function () { return "\n    word-wrap: break-word;\n    text-wrap: balance;\n    text-wrap: pretty;\n  "; };
/**
 * Retrieves the value of the `data-label` attribute from the closest ancestor
 * of the given HTMLDivElement reference.
 *
 * @param element - A React ref object pointing to an HTMLDivElement.
 * @returns The value of the `data-label` attribute of the closest ancestor, or null if not found.
 */
export var getClosestLabel = function (element) {
    if (element.current) {
        // Find the closest ancestor with a data-label attribute
        var closestParent = element.current.closest('[data-label]');
        if (closestParent) {
            return closestParent.getAttribute('data-label');
        }
    }
    return null;
};
